import { motion } from "framer-motion";
import { GALLERY } from "../../lib/siteData";

const Frame = ({ item, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className={`group relative overflow-hidden border border-[#223026] clip-frame bg-[#0F150F] ${
        item.portrait ? "aspect-[3/4]" : "aspect-[4/3]"
      }`}
      data-testid={`gallery-item-${index}`}
    >
      <img
        src={item.url}
        alt={item.label}
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover object-center brightness-95 group-hover:brightness-110 group-hover:scale-[1.04] transition duration-700 ease-out"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
      <div className="absolute top-5 left-5 z-10">
        <span className="bg-black/70 backdrop-blur-sm border border-[#2A3A2E] text-white text-xs uppercase tracking-[0.15em] px-3 py-1.5">
          {item.label}
        </span>
      </div>
    </motion.div>
  );
};

export const Gallery = () => {
  return (
    <section
      id="work"
      className="relative bg-[#080D0A] py-28 md:py-40 border-t border-[#223026]"
      data-testid="gallery-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="mb-16 max-w-2xl">
          <span className="text-sm uppercase tracking-[0.2em] text-lime-400 font-bold">
            Recent Jobs
          </span>
          <h2 className="font-display font-bold tracking-tight text-4xl md:text-6xl text-white mt-4 leading-none">
            Straight from <br /> the field.
          </h2>
          <p className="text-neutral-400 text-base md:text-lg mt-5 max-w-md">
            Real work from real Eklund Land Management jobs — clearing, mulching,
            snow removal and more.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 items-start">
          {GALLERY.map((item, i) => (
            <Frame key={i} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
